<ng-container *ngIf="depth; else noThreadDepthBlock">
  {{ depth | number: '1.1-2' }} {{ 'mm' | translate }}
</ng-container>
<ng-template #noThreadDepthBlock>-</ng-template>
